import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.email.title',
        defaultMessage: 'Email',
    },
    contact: {
        id: 'modal.3ds.email.contact',
        defaultMessage: 'Contact support',
    },
    close: {
        id: 'modal.3ds.email.close',
        defaultMessage: 'Close',
    },
    description: {
        id: 'modal.3ds.email.description',
        defaultMessage:
            "A one-time code is sent to the email address used when this card was created. Enter it on the payment page to confirm. Useful when your phone is unavailable. Check your spam folder if the email doesn't arrive within a minute.<br/><br/>If your email has changed since you got this card, contact support to update it.",
    },
})
